import { Fragment, useState } from "react";
import { Combobox, Dialog, Transition } from "@headlessui/react";
import { MagnifyingGlassIcon } from "@heroicons/react/20/solid";
import { useArticles } from "../../context/ArticlesContext"; // <-- context!
import { useNavigate } from "react-router-dom";

const SearchModal = ({ renderTrigger }) => {
  const [open, setOpen] = useState(false);
  const [rawQuery, setRawQuery] = useState("");
  const [category, setCategory] = useState(0);
  const [subcategory, setSubCategory] = useState(0);

  const { data, loading } = useArticles(); // <-- tutaj pobierasz dane centralnie
  const router = useNavigate();
  const query = rawQuery.toLowerCase().trim();

  const filteredArticles = data
    ?.filter(post => category && post.category_id == category)
    ?.filter(post => subcategory && post.subcategory_id == subcategory)
    ?.filter(post => post.article_title.toLowerCase().includes(query));

  return (
    <>
      <div onClick={() => setOpen(true)} className="cursor-pointer">
        {renderTrigger ? renderTrigger() : (
          <button style={{alignItems:"center"}} className="flex h-10 w-10 rounded-full hover:bg-slate-100">
            <MagnifyingGlassIcon className="h-5 w-5 text-gray-500" />
          </button>
        )}
      </div>

      <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="relative z-[99]" onClose={setOpen}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300" enterFrom="opacity-0" enterTo="opacity-100"
            leave="ease-in duration-200" leaveFrom="opacity-100" leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/40 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 overflow-y-auto p-4 md:p-20">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300" enterFrom="opacity-0 scale-95" enterTo="opacity-100 scale-100"
              leave="ease-in duration-100" leaveFrom="opacity-100 scale-100" leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="mx-auto max-w-2xl bg-white rounded-xl shadow-2xl ring-1 ring-black/10">
                <Combobox onChange={(item) => {
                  router(item.href);
                  setOpen(false);
                }}>

                  <div className="p-4">
                    <div className="mb-2 flex gap-2">
                      <select onChange={(e) => setCategory(Number(e.target.value))}>
                        <option value={0}>Wybierz kategorię</option>
                        <option value={1}>Świat</option>
                        <option value={3}>Kraj</option>
                        <option value={5}>Region</option>
                      </select>
                      <select onChange={(e) => setSubCategory(Number(e.target.value))}>
                        <option value={0}>Wybierz podkategorię</option>
                        <option value={1}>Gospodarka</option>
                        <option value={2}>Polityka</option>
                        <option value={3}>Społeczeństwo</option>
                        <option value={4}>Sport</option>
                      </select>
                    </div>
                    <div className="relative">
                      <MagnifyingGlassIcon className="absolute top-3.5 left-4 h-5 w-5 text-gray-400" />
                      <Combobox.Input
                        className="h-12 w-full pl-11 pr-4 text-gray-900 placeholder:text-gray-400"
                        placeholder="Szukaj..."
                        onChange={(e) => setRawQuery(e.target.value)}
                      />
                    </div>
                  </div>

                  <Combobox.Options className="max-h-80 overflow-y-auto p-4">
                    {filteredArticles?.length > 0 ? (
                      filteredArticles.map((post) => (
                        <Combobox.Option key={post.id} value={post} className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
                          <a
                            href={`/${post?.title.toLowerCase()}/${post?.name.toLowerCase()}/${post?.category_id}/${post?.subcategory_id}/artykuł/${post?.id}`}
                          >
                            {post.article_title}
                          </a>
                        </Combobox.Option>
                      ))
                    ) : (
                      <div className="px-4 py-2 text-sm text-gray-500">Brak wyników</div>
                    )}
                  </Combobox.Options>

                </Combobox>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
};

export default SearchModal;
